import fetch from 'utils/fetch';

// 机构查询消息列表
export function findMessageList(data) {
  return fetch({
    url: '/api/auth/message/findMessageList',
    method: 'post',
    data
  });
}

// 每个角色登录查询消息通知
export function findMessageListByUserId(data) {
  return fetch({
    url: '/api/auth/message/findMessageListByUserId',
    method: 'post',
    data
  });
}

// 更新消息的读取状态
export function updateMessage(data) {
  return fetch({
    url: '/api/auth/message/updateMessageReceiverById',
    method: 'post',
    data
  });
}

//   发送通知
export function sendMeassge(data) {
  return fetch({
    url: '/api/auth/message/sendMeassge',
    method: 'post',
    data
  });
}

//   查询店铺下的收银员、店长
export function findCashier(shopId) {
  return fetch({
    url: '/api/auth/user/findCashierByShopId/' + shopId,
    method: 'get',
  });
}


//   查询机构下的财务账号
export function findFinancial(companyId) {
  return fetch({
    url: '/api/auth/user/findFinancialByCompanyId/' + companyId,
    method: 'get',
  });
}

//   查询机构下的公司账号
export function findFirm(companyId) {
  return fetch({
    url: '/api/auth/user/findFirmBycompanyId/' + companyId,
    method: 'get',
  });
}

//   查询机构下的业务员(BD)账号
export function findBD(companyId) {
  return fetch({
    url: '/api/auth/user/findSalesmanBycompanyId/' + companyId,
    method: 'get',
  });
}



// WEBPACK FOOTER //
// ./src/api/notify/index.js